import React, {useState, useEffect} from 'react'

import "./Situations.css"
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import axios from 'axios';
import ValidationMessage from '../../shared/validationmessage/ValidationMessage';

const model = {
  modulename: "Situations"
};

const SituationEditor = (props) => {

  /* data handling */
  const data = props.data.data;
  const [Id, setId] = useState(data.Id);
  const [SequenceNumber, setSequenceNumber] = useState(data.SequenceNumber);
  const [Name, setName] = useState(data.Name);
  const [Heading, setHeading] = useState(data.Heading);
  const [Description, setDescription] = useState(data.Description);
  const [ManagerType, setManagerType] = useState(data.ManagerType);

  /* file handling */
  const [image, setImage] = useState(axios.defaults.baseURL + '/' + data.ImageUrl);
  const [imageFile, setImageFile] = useState();

  const [video, setVideo] = useState(axios.defaults.baseURL + '/' + data.VideoUrl);
  const [videoFile, setVideoFile] = useState();
  const [ShowSituationsVideo, setShowSituationsVideo] = useState(data.ShowVideo);

  /* exceoption handling */
  const [validations, setValidations] = useState({
      SequenceNumber: [],
      Name: [],
      Heading: [],
      Description: [],
      ManagerType: []
  });

  const resetValidations=()=>{
    setValidations({
      SequenceNumber: [],
      Name: [],
      Heading: [],
      Description: [],
      ManagerType: []
    });
    props.setErrors("");
  }

  const parseErrorResponse=(response)=>{
    if(response.data.errors){
      props.setErrors("");
      setValidations(response.data.errors);
    }
  }

  const handleCancelClick = () => {
    props.setEditorState({open: false, data: null});
  };

  const handleSubmitClick =(e)=>{
    e.preventDefault();

    axios.post('/situations/save', {
      Id: Id,
      Name: Name,
      SequenceNumber: SequenceNumber,
      Heading: Heading,
      Description: Description,
      ManagerType: ManagerType,
      ShowVideo: ShowSituationsVideo
    })
    .then(function (response) {
      resetValidations();

      if(response.data.status == "success"){
        props.setErrors("");
        setId(response.Id);
        if(imageFile){
          uploadFile("image", imageFile);
        }
        else if(videoFile){
          uploadFile("video", videoFile);
        }
        else{
          props.setEditorState({open: false, data: null});
          props.setPageState({loading: false});
        }
      }
      else{
        props.setErrors(response.data.message);
      }
    })
    .catch(function (error) {
      parseErrorResponse(error.response);
    });
    
  };

  const uploadFile=(type, file)=>{
    const formData = new FormData();
      formData.append('Id', Id);
      formData.append('Type', type);
      formData.append('formFile', file);
      axios.post('/situations/upload', formData,{
        headers: {
          "Content-Type": "multipart/form-data",
        }
      })
      .then(function (response) {
        props.setErrors("");
        if (type == "image"){
          if(videoFile){
            uploadFile("video", videoFile);
          }
          else{
            props.setErrors("");
            props.setEditorState({open: false, data: null});
            props.setPageState({loading: false});
          }
        }
        else{
          props.setEditorState({open: false, data: null});
          props.setPageState({loading: false});
        }
      })
      .catch(function (error) {
        props.setErrors(error.message);
      });
  }

  const handleImageFileChange =(e)=>{
    setImage(URL.createObjectURL(e.target.files[0]));
    setImageFile(e.target.files[0]);
  }

  const handleVideoFileChange =(e)=>{
    setVideo(URL.createObjectURL(e.target.files[0]));
    setVideoFile(e.target.files[0]);
  }

  return (
    <form className="form form-md">
      <div className="row mb-3">
        <div className="col">
        <TextField
            required
            className="form-control"
            label="Sequence"
            value={SequenceNumber}
            type="number"
            onChange={e=> setSequenceNumber(e.target.value)}
          />
           <ValidationMessage field="SequenceNumber" errors={validations}/>
        </div>
        <div className="col">
        <TextField
            required
            className="form-control"
            label="Situation"
            value={Name}
            onChange={e=> setName(e.target.value)}
            inputProps={{maxLength :500}}
          />
          <ValidationMessage field="Name" errors={validations}/>
        </div>
        <div className="col">
        <FormControl className="form-control">
          <InputLabel>Manager Type </InputLabel>
          <Select
            required
            label="Manage Type "
            value= {ManagerType}
            onChange={e=> setManagerType(e.target.value)}
          >
          <MenuItem value={1}>First Time Manager</MenuItem>
          <MenuItem value={2}>Middle Manager</MenuItem>
          <MenuItem value={3}>Others</MenuItem>
        </Select>
        <ValidationMessage field="ManagerType" errors={validations}/>
      </FormControl>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
          <TextField
              required
              className="form-control"
              label="Heading"
              value={Heading}
              onChange={e=> setHeading(e.target.value)}
            />
          <ValidationMessage field="Heading" errors={validations}/>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col">
        <TextField
            required
            className="form-control"
            multiline
            rows={7}
            label="Description"
            value={Description}
            onChange={e=> setDescription(e.target.value)}
          />
          <ValidationMessage field="Description" errors={validations}/>
        </div>
      </div>

      <div className="row mb-3 row-media">
        <div className="col">
          <span>Image</span>
          <img src={image} alt={Name}/>
          <label className="upload-file">
            <input className="d-none" type="file" onChange={handleImageFileChange} /> Browser Image...
          </label>
        </div>
        <div className="col">
            <span>Video</span>
            <video width="320" height="240" controls>
              <source src={video} type="video/mp4"/>
            </video>
            <label className="upload-file">
            <input type="file" onChange={handleVideoFileChange} className="d-none" /> Browser Video...
            </label>
            <div className="mb-2 mt-3">
      <div className="form-check form-switch">
        <input className="form-check-input" type="checkbox" role="switch" checked={ShowSituationsVideo ? "checked" : ""} onChange={e=> setShowSituationsVideo(e.target.checked)}/>
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Show Video?</label>
      </div>
      </div>
        </div>
      </div>
      <div className="btn-group">
          <button type="button" className="btn btn-primary" onClick={handleSubmitClick} >Save</button>
          <a className="btn btn-secondary" onClick={handleCancelClick}>Cancel</a>
        </div>
    </form>
  )
}

export default SituationEditor

